import { Action } from "@ngrx/store";
import { Widget } from "../models/widget"
import { DashboardItem } from "../models/dashboard-item"
import { HttpErrorResponse } from '@angular/common/http'

export const MAXIMISE = '[Dashboard] Maximise';
export const RESTORE = '[Dashboard] Restore';
export const DELETE_ITEM = '[Dashboard] Delete Item';
export const MOVE_ITEM = '[Dashboard] Move Item';
export const CLEAR = '[Dashboard] Clear';
export const ADD_WIDGET = '[Dashboard] Add Widget';
export const RESET_DASHBOARD_WIDGETS = '[Dashboard] Reset Widgets';

export const LOAD = '[Dashboard] Load';
export const LOAD_COMPLETE = '[Dashboard] Load Complete';
export const LOAD_ERROR = '[Dashboard] Load Error';

export const SCROLL_DOWN = '[Dashboard] Scroll Down';
export const SCROLL_UP = '[Dashboard] Scroll Up';


export class Load implements Action {
  readonly type = LOAD;
  constructor(public payload: string) { }
}

export class LoadComplete implements Action {
  readonly type = LOAD_COMPLETE;
  constructor(public payload: DashboardItem[]) { }
}

export class LoadError implements Action {
  readonly type = LOAD_ERROR;
  constructor(public payload: HttpErrorResponse) { }
}


export class Maximise implements Action {
  readonly type = MAXIMISE;
  constructor(public payload: Widget) { }
}

export class Restore implements Action {
  readonly type = RESTORE;
  constructor() { }  
}

export class Clear implements Action {
  readonly type = CLEAR;
  constructor() { }
}

export class DeleteItem implements Action {
  readonly type = DELETE_ITEM;
  constructor(public payload: DashboardItem) {}
}

export class AddWidget implements Action {
  readonly type = ADD_WIDGET;
  constructor(public payload: DashboardItem) { }
}


export class MoveItem implements Action {
  readonly type = MOVE_ITEM;
  constructor(public payload: DashboardItem) { }
}

export class ScrollUp implements Action {
  readonly type = SCROLL_UP;
  constructor() { }
}

export class ScrollDown implements Action {
  readonly type = SCROLL_DOWN;
  constructor() { }
}

export class ResetDashboardWidgets implements Action {
  readonly type = RESET_DASHBOARD_WIDGETS;
  constructor(public payload: string) { }
}

export type Actions =
  Maximise |
  Restore |
  DeleteItem |
  MoveItem |
  Load |
  LoadComplete |
  LoadError |
  Clear |
  AddWidget |
  ScrollUp |
  ScrollDown;
